<template>
  <div>
    <el-submenu
      v-if="menu.item && menu.item.length > 0"
      :index="menu.index || ''"
    >
      <template slot="title">
        <i v-if="menu.icon" :class="icon(menu.icon)"></i>
        <img
          style="
            width: 30px;
            image-rendering: -webkit-optimize-contrast;
            border-radius: 5px;
          "
          :src="require('@/assets/logo.png')"
          v-if="menu.logo"
        />
        <span slot="title">{{ menu.text }}</span>
      </template>
      <el-menu-item-group>
        <LeftMenu
          v-for="(item, itemIndex) in menu.item"
          :key="itemIndex"
          :index="item.index"
          :menu="item"
        ></LeftMenu>
      </el-menu-item-group>
    </el-submenu>
    <el-menu-item v-else :index="menu.index">
      <i v-if="menu.icon" :class="icon(menu.icon)"></i>
      <img
        style="
          width: 30px;
          image-rendering: -webkit-optimize-contrast;
          border-radius: 5px;
        "
        :src="require('@/assets/logo.png')"
        v-if="menu.logo"
      />
      <span slot="title">{{ menu.text }}</span>
    </el-menu-item>
  </div>
</template>

<script>
export default {
  name: "LeftMenu",
  props: {
    menu: {
      type: Object,
      default() {
        return null;
      },
    },
  },
  data() {
    return {};
  },
  methods: {
    icon(iconName) {
      if (iconName) {
        return (
          iconName.split("-")[0] + "-" + iconName.split("-")[1] + " " + iconName
        );
      }
    },
  },
};
</script>

<style>
.el-menu--collapse > div > .el-submenu > .el-submenu__title span {
  height: 0;
  width: 0;
  overflow: hidden;
  visibility: hidden;
  display: inline-block;
}
.el-menu--collapse
  > div
  > .el-submenu
  > .el-submenu__title
  .el-submenu__icon-arrow {
  display: none;
}
</style>


// WEBPACK FOOTER //
// src/components/base/LeftMenu.vue